export default async function validatePhone(
  apiEndpoint: string,
  phoneNumber: string
): Promise<boolean> {
  const requestUrl = new URL(apiEndpoint);

  const response = await fetch(requestUrl.toString(), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ number: phoneNumber }),
  });

  return (await response.json()).result;
}
